const ensureOverlayImageLoaded = (overlay) => {
    const overlayImage = overlay.querySelector(".image-lightbox__overlay-image");
    const fullSrc = overlayImage?.dataset.lightboxSrc;

    if (!overlayImage || !fullSrc) {
        return;
    }

    if (overlayImage.getAttribute("src") !== fullSrc) {
        overlayImage.setAttribute("fetchpriority", "high");
        overlayImage.src = fullSrc;
    }
};

const openLightbox = (block) => {
    const trigger = block.querySelector(".image-lightbox__trigger");
    const overlay = block.querySelector(".image-lightbox__overlay");

    if (!trigger || !overlay) {
        return;
    }

    ensureOverlayImageLoaded(overlay);

    overlay.hidden = false;
    overlay.setAttribute("aria-hidden", "false");
    trigger.setAttribute("aria-expanded", "true");
    block.classList.add("image-lightbox--open");
    document.body.classList.add("image-lightbox-open");
};

const closeLightbox = (block) => {
    const trigger = block.querySelector(".image-lightbox__trigger");
    const overlay = block.querySelector(".image-lightbox__overlay");

    if (!trigger || !overlay) {
        return;
    }

    overlay.hidden = true;
    overlay.setAttribute("aria-hidden", "true");
    trigger.setAttribute("aria-expanded", "false");
    block.classList.remove("image-lightbox--open");
    document.body.classList.remove("image-lightbox-open");
};

export const initImageLightbox = (blockWrapper) => {
    const blocks = blockWrapper.classList.contains("image-lightbox")
        ? [blockWrapper]
        : blockWrapper.querySelectorAll(".image-lightbox");

    blocks.forEach((block) => {
        if (block.dataset.lightboxInit === "1") {
            return;
        }

        const trigger = block.querySelector(".image-lightbox__trigger");
        const overlay = block.querySelector(".image-lightbox__overlay");

        if (!trigger || !overlay) {
            return;
        }

        trigger.addEventListener("click", () => {
            openLightbox(block);
        });

        overlay.addEventListener("click", () => {
            closeLightbox(block);
        });

        block.dataset.lightboxInit = "1";
    });
};

const setupImageLightbox = () => {
    const blocks = document.querySelectorAll(".image-lightbox");
    blocks?.forEach(initImageLightbox);
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupImageLightbox);
} else {
    setupImageLightbox();
}
